import { render, staticRenderFns } from "./PazarForushgahiHero.vue?vue&type=template&id=0e71ac73&scoped=true"
import script from "./PazarForushgahiHero.vue?vue&type=script&lang=js"
export * from "./PazarForushgahiHero.vue?vue&type=script&lang=js"
import style0 from "./PazarForushgahiHero.vue?vue&type=style&index=0&id=0e71ac73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71ac73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
